import { Component } from "react";
import { Grid } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import { options } from "esri-leaflet";

const REGION_TYPE = {
  'กรมการปกครอง': 'dopa',
  'กรมทรัพยากรน้ำ': 'dwr',
}
class FilterPanel extends Component {

  constructor(props) {
    super(props)
    let dwrRegion = [... new Set(this.props.area.map(a => a.dwr_region).filter(a => a!==null))]
    let dopaRegion = [... new Set(this.props.area.map(a => a.dopa_region).filter(a => a!==null))]
    this.state = {
      area: [],
      filteredArea: [],
      optionFilterArea: [],
      dwrRegion: dwrRegion,
      dopaRegion: dopaRegion,
      selectedRegionOption: dopaRegion,

      // filteredStation: 0,
      selectedProvince: this.props.filter.province,
      selectedAmphoe: this.props.filter.amphoe,
      selectedTambon: this.props.filter.tambon,
      selectedRegion: "ภาคเหนือ",
      selectedRegionType: Object.keys(REGION_TYPE)[0],
    }
    this.filterArea = this.filterArea.bind(this);
  }

  async componentDidMount() {
    await this.setState({
      area: this.props.area,
    })
    this.filterArea()
  }

  // setFilteredStationNumber() {

  // }

  async filterArea() {
    let _filter = []
    let _optionFilterArea = []
    if(this.state.selectedRegion === null &&
        this.state.selectedTambon === null &&
        this.state.selectedAmphoe === null &&
        this.state.selectedProvince === null) {
          _filter = this.state.area
          _optionFilterArea = this.state.area
    } else {
      _filter = this.state.area
      
      // console.log(_filter)
      if(this.state.selectedRegion!==null) {
        if(REGION_TYPE[this.state.selectedRegionType]==='dopa') {
          _filter = _filter.filter(d => d.dopa_region === this.state.selectedRegion)
        }
        if(REGION_TYPE[this.state.selectedRegionType]==='dwr') {
          // console.log(this.state.selectedRegionType, this.state.selectedRegion)
          _filter = _filter.filter(d => d.dwr_region === this.state.selectedRegion)
        }
      }
      _optionFilterArea = _filter
      // console.log(this.state.selectedRegion, _filter)
      if(this.state.selectedProvince!==null) {
        _filter = _filter.filter(d => d.province === this.state.selectedProvince)
      }
      if(this.state.selectedAmphoe!==null) {
        _optionFilterArea = _optionFilterArea.filter(d => d.province === this.state.selectedProvince)
        _filter = _filter.filter(d => d.amphoe === this.state.selectedAmphoe)
      }
      if(this.state.selectedTambon!==null) {
        _optionFilterArea = _optionFilterArea.filter(d => d.amphoe === this.state.selectedAmphoe)
        _filter = _filter.filter(d => d.tambon === this.state.selectedTambon)
      }
    }
    // console.log(_optionFilterArea)
    await this.setState({
      filteredArea: _filter,
      optionFilterArea: _optionFilterArea,
    })
  }

  handleRegionTypeChange = async (event, value) => {
    let options = []
    if (REGION_TYPE[value] == 'dopa') {
      options = this.state.dopaRegion
    } else if (REGION_TYPE[value] == 'dwr') {
      options = this.state.dwrRegion
    }
    await this.setState({
      selectedRegionType: value,
      selectedRegionOption: options,
    })
  }

  handleRegionChange = async (event, value) => {
    await this.setState({
      selectedRegion: value,
      selectedProvince: null,
    })
    this.filterArea()
    this.onFilterChange()
  }

  handleProvinceChange = async (event, value) => {
    await this.setState({
      selectedProvince: value
    })
    this.filterArea()
    this.onFilterChange()
  }

  
  handleAmphoeChange = async (event, value) => {
    await this.setState({
      selectedAmphoe: value
    })
    this.filterArea()
    this.onFilterChange()
  }

  handleTambonChange = async (event, value) => {
    await this.setState({
      selectedTambon: value
    })
    this.filterArea()
    this.onFilterChange()
  }

  onFilterChange = () => {
    let dwr_region = null
    let dopa_region = null
    if (REGION_TYPE[this.state.selectedRegionType] === 'dopa') {
      dopa_region = this.state.selectedRegion
    } else if (REGION_TYPE[this.state.selectedRegionType] === 'dwr') {
      dwr_region = this.state.selectedRegion
    }
    let payload = {
      dwr_region: dwr_region,
      dopa_region: dopa_region,
      province: this.state.selectedProvince,
      amphoe: this.state.selectedAmphoe,
      tambon: this.state.selectedTambon,
    }
    this.props.onFilterChange(payload)
  }

  clearFilter = async () => {
    await this.setState({
      selectedRegion: Object.keys(REGION_TYPE)[0],
      selectedProvince: null,
      selectedAmphoe: null,
      selectedTambon: null,
    })
    this.onFilterChange();
  }

  render() {
    let filterStation = this.props.filteredStations?this.props.filteredStations.length:0
    let totalStation = this.props.totalStations?this.props.totalStations.length:0
    // console.log()
    return (
      <Box>
        <Grid container spacing={1}>
        <Grid item xs={12} md={6} lg={2} >
            <Autocomplete
              disablePortal
              id="region-type"
              value={this.state.selectedRegionType}
              onChange={this.handleRegionTypeChange}
              options={Object.keys(REGION_TYPE)}
              renderInput={(params) => <TextField {...params} label="ประเภทของภูมิภาค" />}
            />
        </Grid>
        <Grid item xs={12} md={6} lg={2} >
            <Autocomplete
              disablePortal
              id="region"
              value={this.state.selectedRegion}
              onChange={this.handleRegionChange}
              options={this.state.selectedRegionOption}
              renderInput={(params) => <TextField {...params} label="ภูมิภาค" />}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3} >
            <Autocomplete
              disablePortal
              id="province"
              value={this.state.selectedProvince}
              onChange={this.handleProvinceChange}
              options={[...Array.from(new Set(this.state.filteredArea.map(d=>d.province))).sort()]}
              renderInput={(params) => <TextField {...params} label="จังหวัด" />}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3} >
            <Autocomplete
              disablePortal
              id="amphoe"
              value={this.state.selectedAmphoe}
              onChange={this.handleAmphoeChange}
              options={[...Array.from(new Set(this.state.filteredArea.map(d=>d.amphoe))).sort()]}
              renderInput={(params) => <TextField {...params} label="อำเภอ" />}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={2} >
            <Autocomplete
              disablePortal
              id="tambon"
              value={this.state.selectedTambon}
              onChange={this.handleTambonChange}
              options={[...Array.from(new Set(this.state.filteredArea.map(d=>d.tambon))).sort()]}
              renderInput={(params) => <TextField {...params} label="ตำบล" />}
            />
          </Grid>
        </Grid>

        <Grid container spacing="10" paddingTop={1}>
          <Grid item>
          <Typography align="left" variant="inherit"> 
            *แสดงข้อมูลจากการกรอง {filterStation} จากทั้งหมด {totalStation} สถานี 
          </Typography>
          </Grid>
          <Grid item>
            <Typography  
              variant="caption" 
              sx={{textDecoration: 'underline'}} 
              onClick={this.clearFilter}>
                ล้างตัวกรองข้อมูล
            </Typography >
          </Grid>
         
        </Grid>
      </Box>
    )
  }
}

export default FilterPanel